<template>
  <div v-loading="pageLoading">
    <div>
      <h3>{{ title }}</h3>
      <p>時間：{{ time }}</p>
      <p>發佈人員：{{ name }}</p>
    </div>
    <hr />
    <div class="content"
         v-html="content">
    </div>
    <el-button class="btn"
               @click="$router.back(-1)">返 回</el-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pageLoading: false,
      title: '',
      time: '',
      name: '',
      content: ""
    };
  },
  methods: {
    download () {
      location.href = this.file
    }
  },
  mounted () {
    $('#pageHead').text('查看花絮');

    var id = sessionStorage.getItem('activityId');
    this.pageLoading = true
    this.axios({
      url: '/manage/getCheckTrivia',
      params: {
        id: id
      }
    }).then(res => {
      if (res) {
        let msg = res.result;
        this.name = msg.name;
        this.time = msg.uploadTime;
        this.title = msg.activityName;
        this.content = msg.content;
      }
      this.pageLoading = false
    });
  }
};
</script>

<style scoped>
p {
  color: #999;
}
div {
  text-align: center;
}
hr {
  border-bottom: none;
  border-top: 3px solid #999;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.content * {
  max-width: 100%;
}
</style>
